import './WhitePopUpStyles.css';

import { faTimes, faTimesCircle } from '@fortawesome/sharp-regular-svg-icons';
import { useRef } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/button/Button';
import useKeyboardAction from '../../hooks/useKeyboardAction';
import { renderTextWithLineBreaks } from '../../util/renderTextWithLineBreaks';

function WhitePopUpNoTitle({
  popupContents,
  ctaBtn,
  handleSubmit,
  returnFocus,
  dialogTitle = null,
}) {
  const modalRef = useRef(null);
  const { t } = useTranslation();

  useKeyboardAction(() => {
    handleSubmit();
  }, 'Escape');

  return (
    <FocusLock returnFocus={returnFocus}>
      <div
        className="popup-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        ref={modalRef}
      >
        <div className="popup-container results">
          <Button
            ariaLabel={t('modal.close')}
            className="close-icon"
            icon={{ faIconDefinition: faTimesCircle }}
            onClick={handleSubmit}
            variant="icon-only"
          />
          <h2 className="popup-title" id="modal-title">
            {popupContents.title || dialogTitle}
          </h2>
          <div className="popup-body">
            <div className="popup-text-container">
              {popupContents.text.map((item, index) => (
                // Static popup copy and the index also picks the mid heading style.
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className={index === 1 ? 'mid-heading' : ''}>
                  {renderTextWithLineBreaks(item)}
                </div>
              ))}
            </div>
          </div>
          <div className="popup-cta single">
            <Button
              className="wb"
              onClick={handleSubmit}
              color="dark"
              icon={{ faIconDefinition: faTimes }}
            >
              {ctaBtn}
            </Button>
          </div>
        </div>
      </div>
    </FocusLock>
  );
}

export default WhitePopUpNoTitle;
